import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuRegenerationService {
  private readonly menuRegenerationSubject = new Subject<void>();
  public readonly menuRegeneration$ = this.menuRegenerationSubject.asObservable();

  public triggerMenuRegeneration(): void {
    this.menuRegenerationSubject.next();
  }
}
